@if (isDataLoadedForUser) {
  <p-dialog
    header="Please complete your registration"
    [(visible)]="display"
    [closable]="false"
    [modal]="true"
    [style]="{ width: '35vw' }"
    [baseZIndex]="10000"
    [draggable]="false"
    [resizable]="false"
  >
    <form [formGroup]="userFields">
      <div class="required-field-disclaimer padding-bottom-a-rem">
        Required fields are marked with a red asterisk<span class="red">*</span>
      </div>
      <div class="grid">
        <div class="col-3 px-0">
          <label class="control-label float-left pl-2" for="FirstName"
            >First Name<span class="error-label">*</span>:</label
          >
        </div>
        <div class="col-9">
          <input
            [class.is-invalid]="f.FirstName.invalid && f.FirstName.touched"
            pattern=".*\S+.*"
            type="text"
            class="form-control input-border full-width"
            formControlName="FirstName"
            aria-label="First name"
            pInputText
            autofocus
          />
          @if (
            (f.FirstName.invalid && f.FirstName.touched) || f.FirstName.dirty
          ) {
            <div class="float-left">
              @if (f.FirstName.errors?.required) {
                <small class="error-label">First Name is required</small>
              }
              @if (f.FirstName.errors?.pattern) {
                <small class="error-label">Invalid characters</small>
              }
            </div>
          }
        </div>
        <div class="col-3 px-0">
          <label class="control-label float-left pl-2" for="FamilyName"
            >Last Name<span class="error-label">*</span>:</label
          >
        </div>
        <div class="col-9">
          <input
            [class.is-invalid]="f.FamilyName.invalid && f.FamilyName.touched"
            pattern=".*\S+.*"
            type="text"
            class="input-border full-width"
            formControlName="FamilyName"
            aria-label="Last name"
            pInputText
          />
          @if (
            (f.FamilyName.invalid && f.FamilyName.touched) || f.FamilyName.dirty
          ) {
            <div class="float-left">
              @if (f.FamilyName.errors?.required) {
                <small class="error-label">Last Name is required</small>
              }
              @if (f.FamilyName.errors?.pattern) {
                <small class="error-label">Invalid characters</small>
              }
            </div>
          }
        </div>
      </div>
      <br />
      <div class="grid flex-row-reverse">
        <button
          pButton
          type="button"
          class="margin-right"
          (click)="saveUser()"
          [disabled]="!userFields.valid"
          label="Save"
        ></button>
      </div>
    </form>
  </p-dialog>
}
